export default __webpack_public_path__ + "static/img-mobile-c47ad7c1f3ebca4da3c1f1f5357c84d3.webp";